import I18n from '~/src/common/services/I18n';

import ImageApp from './application.png';
import * as S from './layout';
import ImageQRCode from './scan.png';
import Star from './star.svg';

interface Props {
  className?: string;
}

export const MobileIncentiveBanner = (props: Props) => {
  return (
    <S.Root className={props.className}>
      <S.ImageAndInformations>
        <img src={ImageApp} />

        <S.Informations>
          <S.TitleAndRating>
            <S.Title>{I18n.t('home.mobile-incentive.title')}</S.Title>

            <S.Rating>
              <S.Stars>
                {[1, 2, 3, 4, 5].map(n => (
                  <Star key={n} width={16} height={16} aria-label="star" role="img" />
                ))}
              </S.Stars>

              <S.RatingLabel>
                4,9 {I18n.t('home.mobile-incentive.rating', { count: '5,4' })}
              </S.RatingLabel>
            </S.Rating>
          </S.TitleAndRating>

          <S.Description>{I18n.t('home.mobile-incentive.description')}</S.Description>
        </S.Informations>
      </S.ImageAndInformations>

      <S.QRCode src={ImageQRCode} />

      <S.Stores>
        <S.AppStore />
        <S.GooglePlay />
      </S.Stores>
    </S.Root>
  );
};
